import { Column, Entity, PrimaryGeneratedColumn, ManyToOne, OneToOne, OneToMany } from "typeorm"
import { Rule } from "./Rule.entity";
import { ContractTariffLiveData } from "./ContractTariffLiveData"
import { Tariff } from "./Tariff.entity"
import { HistoricalTariffUsageDaily } from "./HistoricalTariffUsageDaily";
import { HistoricalTariffUsageMonthly } from "./HistoricalTariffUsageMonthly";
import { float2dp } from "../../transofrmers/Float2p";

@Entity()
export class ContractTariff {

  @PrimaryGeneratedColumn({ name:"id" })
  id?: number;
  
  @Column({nullable : false})
  client_name!: string

  @Column({nullable:true, default: null})
  client_label!: string
  
  @ManyToOne(() => Tariff, tariff => tariff.contracts, { eager: true, onDelete:'CASCADE', onUpdate:'CASCADE' })
  tariff!: Tariff

  @Column({default : 0})
  data_cost!: number

  @Column({default : 0})
  voice_cost!: number

  @Column({default : 0})
  sms_cost!: number

  @Column({default:true})
  include_in_flexi_tariff!: boolean

  @Column({default:false})
  include_in_flexi_tariff_override!: boolean

  @Column({default:false})
  include_cancel_location!: boolean

  @Column({default:true})
  show_in_map!: boolean

  @Column({default:false})
  allow_activation_sms!: boolean

  @Column({default:false})
  allow_network_exclusion!: boolean

  @OneToOne(() => ContractTariffLiveData, ctld => ctld.contract_tariff, { onDelete:'CASCADE' })
	live_data!: ContractTariffLiveData

  @OneToMany(() => HistoricalTariffUsageDaily, dailyUsage => dailyUsage.contract_tariff)
  historical_daily_usage!: HistoricalTariffUsageDaily[]

  @OneToMany(() => HistoricalTariffUsageMonthly, monthlyUsage => monthlyUsage.contract_tariff)
  historical_monthly_usage!: HistoricalTariffUsageMonthly[]

  @OneToMany(() => Rule, rule => rule.tariff)
  rules!: Rule[]

  @Column({ type: 'json', nullable : false }) 
  remoteSocketContacts!: string[]

  @Column({ transformer:float2dp })
  flexy_tariff_multiplier!: number
  
}